import { call } from "@/firebase";
// eslint-disable-next-line no-restricted-imports
import {
  startAuthentication as startAuthenticationReal,
  startRegistration,
  WebAuthnError,
} from "@simplewebauthn/browser";

export { startRegistration, WebAuthnError };

// aircap-dev sets VITE_TREEZOR_SCA_PASSKEY_BYPASS. In Vite dev that swaps the passkey prompt
// for a Treezor sandbox scaProof. Call the matching *SCAPayload callable first: the proof signs its challenge.
export const startAuthentication = async (...args: Parameters<typeof startAuthenticationReal>) => {
  if (import.meta.env.DEV && import.meta.env.VITE_TREEZOR_SCA_PASSKEY_BYPASS === "true") {
    const { scaProof } = await call("simulateTreezorScaProof")({});
    return scaProof;
  }
  return startAuthenticationReal(...args);
};
